const GEN_AI_ONBOARDING_KEY = 'genAIOnboarding'

export const setSessionGenAiOnboarding = (key, value) => {
  let newGenAIOnboarding = {}
  let genAIOnboarding = sessionStorage.getItem(GEN_AI_ONBOARDING_KEY)
  genAIOnboarding = genAIOnboarding ? JSON.parse(genAIOnboarding) : null

  if (genAIOnboarding) {
    newGenAIOnboarding = {
      ...genAIOnboarding,
      [key]: value,
    }
  } else {
    newGenAIOnboarding = {
      [key]: value,
    }
  }
  sessionStorage.setItem(
    GEN_AI_ONBOARDING_KEY,
    JSON.stringify(newGenAIOnboarding),
  )
}
